import { ApiClient } from '@/shared/api/client';

/** 로그인한 계정. `menus`는 팀 기본 권한 ∪ 개별 권한 — 화면 메뉴를 이걸로 거른다. */
export interface SignedInAccount {
  id: number;
  email: string;
  name: string;
  menus: string[];
}

export interface ConsoleSession {
  /** 로그인을 강제하는가(서버 `CONSOLE_LOGIN_REQUIRED`). 꺼져 있으면 로그인 없이 모든 메뉴가 열린다. */
  required: boolean;
  account: SignedInAccount | null;
}

export const loginApi = {
  session: () => ApiClient.getJson<ConsoleSession>('/auth/session'),
  start: (email: string, password: string) => ApiClient.postJson<{ challengeId: string; expiresAt: string }>('/auth/login', { email, password }),
  verify: (challengeId: string, code: string) => ApiClient.postJson<void>('/auth/login/code', { challengeId, code }),
  logout: () => ApiClient.deleteJson<void>('/auth/session'),
  completePasswordSetup: (token: string, password: string) => ApiClient.postJson<void>('/auth/password-setup', { token, password }),

  /**
   * 지금 세션. 액세스 토큰(15분)이 끝나 계정이 비어 오면 리프레시 토큰으로 한 번 바꿔 다시 묻는다 — 새로고침할 때마다
   * 로그인 화면으로 튕기지 않게.
   */
  async current(): Promise<ConsoleSession> {
    const session = await loginApi.session();
    if (session.account || !session.required) return session;
    return (await ApiClient.refreshSession()) ? loginApi.session() : session;
  },
};
